// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PartyCards_partyCards__tAUC8 {
  width: 100%;
}
.PartyCards_partyCards__tAUC8 .PartyCards_partyCardsBox__fEREQ {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(96px, 1fr));
  flex-wrap: wrap;
  gap: 24px;
}
@media (max-width: 600px) {
  .PartyCards_partyCards__tAUC8 .PartyCards_partyCardsBox__fEREQ {
    grid-template-columns: repeat(auto-fill, minmax(70px, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/DashBordCards/PartyCards.module.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;AACD;AACC;EACC,aAAA;EACA,2DAAA;EACA,eAAA;EACA,SAAA;AACF;AACE;EAND;IAOE,2DAAA;EAED;AACF","sourcesContent":[".partyCards {\r\n\twidth: 100%;\r\n\r\n\t.partyCardsBox {\r\n\t\tdisplay: grid;\r\n\t\tgrid-template-columns: repeat(auto-fill, minmax(96px, 1fr));\r\n\t\tflex-wrap: wrap;\r\n\t\tgap: 24px;\r\n\r\n\t\t@media (max-width: 600px) {\r\n\t\t\tgrid-template-columns: repeat(auto-fill, minmax(70px, 1fr));\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"partyCards": `PartyCards_partyCards__tAUC8`,
	"partyCardsBox": `PartyCards_partyCardsBox__fEREQ`
};
export default ___CSS_LOADER_EXPORT___;
